import { AxiosError } from 'axios';
import { fetcher, getRequestConfig, UnauthorizedError } from './fetcher';

export type Context = 'auto' | 'home';

const Paths = {
  CAN_REVIEW: (context: Context = 'auto') => `/${context}/can-review`,
};

export type Result = {
  reviewButton: boolean;
  hasDebt: boolean;
};

const getAvailableLeadReview = async (context: Context = 'auto'): Promise<Result> => {
  try {
    const response = await fetcher.get(Paths.CAN_REVIEW(context), getRequestConfig());

    return response.data;
  } catch (error) {
    if ((error as AxiosError)?.response?.status === 401) {
      throw new UnauthorizedError((error as AxiosError)?.message);
    }

    throw new Error(`Could not get can review - ${error}`);
  }
};

export { getAvailableLeadReview };
